class Store {
  private store?: Storage;
  private _isRemember?: boolean;

  constructor(isRemember: boolean) {
    this.setRemember(isRemember);
  }

  setRemember = (isRemember = false) => {
    this._isRemember = isRemember;
    localStorage.setItem('isRemember', isRemember.toString());
    this.store = isRemember ? localStorage : sessionStorage;
  };

  isRemember(): boolean {
    return !!this._isRemember;
  }

  setItem(key: string, value: string) {
    this.store!.setItem(key, value);
  }

  getItem = (key: string) => {
    return this.store!.getItem(key);
  };

  removeItem = (key: string) => {
    return this.store!.removeItem(key);
  };

  clear = () => {
    this.store!.clear();
  };
}

const isRemember = localStorage.getItem('isRemember');

export default new Store(isRemember === null ? false : isRemember === 'true');
